import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../shared/Auth/UseAuth'
import FloatAddButton from '../../widgets/float_add/float_button_add'
import { AppShell } from '../../shared/layout/AppShell'

export const ProtectedLayout = ({
  children,
}: {
  children: JSX.Element
  // local era usado pelo Topo antigo para o breadcrumb. O AppShell deriva
  // o breadcrumb do pathname via CRUMB_MAP, então a prop deixou de ser
  // necessária. Mantida como opcional pra não quebrar os call-sites.
  local?: any
}) => {
  const auth = useAuth()
  const navigate = useNavigate()

  // Chamar navigate dentro do render é um side-effect: React 18 em strict
  // mode reclama. Isolado em useEffect agora.
  useEffect(() => {
    if (!auth.userId) navigate('/login')
  }, [auth.userId, navigate])

  if (!auth.userId) return null

  return (
    <AppShell>
      {children}
      <FloatAddButton />
    </AppShell>
  )
}
